import React, { Component } from 'react';
import { connect } from 'react-redux';

import Loading from '../../core/Loading';
import ChannelShareDetail from '../../views/Audiences/channelShareDetail';

import { setDataDailyShare } from '../../../actions';

class ChannelShareDetailWrapper extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: !props.dataDailyShare,
      dataDailyShare: props.dataDailyShare
    };
  }

  componentDidMount() {
    const { setDataDailyShareHandler } = this.props;
    const { dataDailyShare } = this.state;

    if (!dataDailyShare) {
      setDataDailyShareHandler()
        .then(data => {
          this.setState({
            loading: false,
            dataDailyShare: data
          });
        })
        .catch(() => {
          this.setState({
            loading: false,
            onErrorLoadData: true
          });
        });
    }
  }

  getRender = () => {
    const { loading, dataDailyShare, onErrorLoadData } = this.state;
    if (loading) {
      return <Loading size="xl" />;
    }
    if (onErrorLoadData) {
      return (
        <p>Lo sentimos, pero no tenemos datos para la fecha seleccionada</p>
      );
    }
    return <ChannelShareDetail data={dataDailyShare} />;
  };

  render() {
    return this.getRender();
  }
}

const mapStateToProps = state => ({
  dataDailyShare: state.audiences.dataDailyShare
});

const mapDispatchToProps = dispatch => ({
  setDataDailyShareHandler: () => setDataDailyShare(dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChannelShareDetailWrapper);
